import { DataObject, ObjectPropertyValues } from '@sageworks/jpi';

export const convertObjectPropertyValuesToDataObject = (objectPropertyValues: ObjectPropertyValues): DataObject => {
	return {
		rowId: objectPropertyValues.id,
		values: objectPropertyValues.dataFieldValues,
	};
};